/**
 * @west-tennessee-consulting/ai-compose — portable AI reply-assist for email composing.
 *
 * Backend-agnostic: prompt builders + UI live here; each app supplies its own
 * authenticated LLM endpoint. Hub points the toolbar at /api/ai/reply-assist
 * (Amazon Nova Lite). Reusable by next-email-client and Slack compose flows.
 */

export type {
  AiReplyIntent,
  AiReplyContext,
  AiReplyPromptInput,
  AiReplyRequest,
  AiReplyResponse,
} from "./types.js";

export {
  AI_REPLY_INTENTS,
  AI_REPLY_TRANSFORM_INTENTS,
  type AiReplyIntentMeta,
} from "./intents.js";

export {
  buildReplyAssistPrompt,
  PROMPT_BUILDERS,
  type ReplyAssistPrompt,
  type ReplyAssistPromptBuilder,
} from "./prompts/index.js";

export {
  AiReplyAssistToolbar,
  type AiReplyAssistToolbarProps,
} from "./AiReplyAssistToolbar.js";

export {
  useAiReplyAssist,
  type UseAiReplyAssistOptions,
  type UseAiReplyAssistResult,
} from "./useAiReplyAssist.js";
